import { List, ListItem as ListItemMUI } from '@material-ui/core';
import { Facebook, YouTube, Instagram } from '@material-ui/icons';

import styled from 'styled-components';

import { mediaQueries, getColorHeader } from '../../../../libs';

export const ListItem = styled(ListItemMUI)`
  padding: 5px !important;
  font-size: 13px !important;
  width: fit-content !important;
`;

export const Link = styled.a`
  color: #555555;
  display: flex;
  align-items: center;
  font-size: 13px;
  min-width: 80%;

  &:hover {
    color: ${getColorHeader};
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    height: 30px;
  }
`;

export const StyledLink = styled.a`
  font-weight: bold;
  font-size: 13px;
  color: #444;
  padding: 5px;

  &:hover {
    color: ${getColorHeader};
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    text-align: center;
  }
`;

export const SvgList = styled(List)`
  display: flex !important;
  padding: 0 !important;
  justify-content: flex-start;
`;

export const SvgTicket = styled.svg`
  width: 30px;
  height: 30px;
  padding: 2px;
  fill: #606060;
`;

export const FacebookIcon = styled(Facebook)`
  font-size: 30px !important;

  * {
    color: #3b5998 !important;
    fill: #3b5998 !important;
  }
`;

export const YouTubeIcon = styled(YouTube)`
  font-size: 30px !important;
  * {
    color: #bb0000 !important;
    fill: #bb0000 !important;
  }
`;

export const BlogSvg = styled.svg`
  height: 23px;
  width: 23px;
`;

export const InstagramIcon = styled(Instagram)`
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  ) !important;

  font-size: 25px !important;
  border-radius: 6px;
  padding: 1px;

  * {
    color: #fff !important;
    fill: #fff !important;
  }
`;
